import { render, staticRenderFns } from "./GameItemsEditForm.vue?vue&type=template&id=095fe4fb&scoped=true&"
import script from "./GameItemsEditForm.vue?vue&type=script&lang=js&"
export * from "./GameItemsEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095fe4fb",
  null
  
)

export default component.exports